import { Component, inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { SwalService } from '@shared/utils/swal.service';
import { UserService } from '@pages/user/services/user.service';
import { CryptDataService } from '@shared/utils/crypt-data.service';
import { LogService } from '@shared/services/Log/log.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
  })
  export class ChangePasswordComponent implements OnInit {
    private _snackBar = inject(MatSnackBar);
    version = environment.version;
    logo = environment.logo || 'cafam.png';
    currentYear = new Date().getFullYear();
    showIngresePassword : boolean = false;
    strEmail : string;
    formData : UntypedFormGroup;
    btnSendEnable : boolean = true;
    loading : boolean = false;
    constructor( private router: Router,
                 private swalService: SwalService,
                 private _userServices: UserService,
                 private crypto : CryptDataService,
                 private logService : LogService
    ) {}

    ngOnInit(): void {
        // Buscar primero en "cambiarEmail" (redirigido desde login), luego en "Usser" (usuario autenticado)
        let emailSesion : string | null = sessionStorage.getItem("cambiarEmail") || sessionStorage.getItem("Usser");
        if(emailSesion != null){
          this.showIngresePassword = false;
          this.strEmail = emailSesion.includes('"') ? JSON.parse(emailSesion) : emailSesion;
          
        }
        this.InitForm();
      }

      InitForm(){
        this.formData = new UntypedFormGroup({
          passwordLast: new UntypedFormControl('', [Validators.required]),
          passwordNew: new UntypedFormControl('', [Validators.required,Validators.minLength(6)]),
          passwordNewConfirm: new UntypedFormControl('', [Validators.required,Validators.minLength(6)]),
          
        });
    
        this.formData.get('passwordNewConfirm').setValidators([
          Validators.required,
          Validators.minLength(6),
          (control: UntypedFormControl) => {
            const passwordNew = this.formData.get('passwordNew').value;
            const passwordNewConfirm = control.value;
            return passwordNew === passwordNewConfirm ? null : { notMatch: true };
          },
        ]);
        
      }

      log(payload : any){
        this.logService.LogAccionesTrasabilidad(payload);
      }

      updateUser(){
        this.loading = true;
        this.formData.disable();
        const passwordNew : string = this.crypto.encryptDataSessionSHA256("",this.formData.controls["passwordNew"].value,false);
        const passwordLast : string = this.crypto.encryptDataSessionSHA256("",this.formData.controls["passwordLast"].value,false);
        let payload : any = {
          "email": this.strEmail,
          "password": this.formData.controls['passwordNew'].value,
          "passwordEncryp": passwordNew,
          "passwordAntE": passwordLast                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
        }
        this._userServices.UpdatePassword(payload).subscribe(x => {
          this.formData.enable();
          this.loading = false;
          this.swalService.success("Se ha actualizado la contraseña");
          this.openSnackBar("Se ha actualizado la contraseña", "Cerrar");
          this.router.navigateByUrl("sign-in");
        },err => {
          this.swalService.error(err.error.mensaje);
          this.openSnackBar(err.error.mensaje, 'Cerrar')
          this.loading = false;
    
          this.formData.enable();
          console.log(' password error =>',err);
        });
        console.log(payload)
      }

      openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action);
      }

      validateFields() {
        const passwordLast = this.formData.controls['passwordLast'].value;
        const passwordNew = this.formData.controls['passwordNew'].value;
        const passwordNewConfirm = this.formData.controls['passwordNewConfirm'].value;
      
        // Validar si los campos están vacíos
        if (!passwordLast || !passwordNew || !passwordNewConfirm) {
          this.openSnackBar('Todos los campos son obligatorios.', 'Cerrar');
          return;
        }

        // Validar que la contraseña anterior no sea la misma que la nueva
        if (passwordLast == passwordNew) {
          this.openSnackBar('La nueva contraseña no puede ser igual a la anterior.', 'Cerrar');
          return;
        }
      
        // Validar longitud de la contraseña (mínimo 8, máximo 20)
        if (passwordNew.length < 8 || passwordNew.length > 20) {
          this.openSnackBar('La contraseña debe tener entre 8 y 20 caracteres.', 'Cerrar');
          return;
        }
      
        // Validar que la contraseña tenga al menos una letra mayúscula, un número y un carácter especial
        const regexMayuscula = /[A-Z]/;
        const regexNumero = /[0-9]/;
        const regexEspecial = /[!@#$%^&*(),.?":{}|<>]/;
      
        if (!regexMayuscula.test(passwordNew) || !regexNumero.test(passwordNew) || !regexEspecial.test(passwordNew)) {
          this.openSnackBar('La contraseña debe contener al menos una letra mayúscula, un número y un carácter especial.', 'Cerrar');
          return;
        }
      
        // Validar que las contraseñas coincidan
        if (passwordNew !== passwordNewConfirm) {
          this.openSnackBar('Las contraseñas no coinciden.', 'Cerrar');
          return;
        }
      
        // Validar que no haya secuencias de 4 números ascendentes o descendentes
        const secuenciaAscendente = /0123|1234|2345|3456|4567|5678|6789/;
        const secuenciaDescendente = /9876|8765|7654|6543|5432|4321|3210/;
      
        if (secuenciaAscendente.test(passwordNew) || secuenciaDescendente.test(passwordNew)) {
          this.openSnackBar('La contraseña no puede contener secuencias de 4 números ascendentes o descendentes.', 'Cerrar');
          return;
        }
      
        // Si pasa todas las validaciones, se puede proceder con el cambio de contraseña
        this.updateUser();
      }
}